import { render } from "./403.vue?vue&type=template&id=c4adb63e&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"

import "./403.vue?vue&type=style&index=0&id=c4adb63e&scoped=true&lang=css"
import "./403.vue?vue&type=style&index=1&id=c4adb63e&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4adb63e"]])

export default __exports__